import { render, staticRenderFns } from "./CourseManage.vue?vue&type=template&id=6c618976&"
import script from "./CourseManage.vue?vue&type=script&lang=js&"
export * from "./CourseManage.vue?vue&type=script&lang=js&"
import style0 from "./CourseManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports